import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import { EEvaluationUnit } from 'store/deal-evaluation/types';
import labels from 'constants/labels';
import { testIdUnitToggleDollarPerTon, testIdUnitToggleCentPerPound } from 'components/unit-toggle/test-ids';

export const { activeBackground, darkInputBorder, globalInputSelectedBg, primary, white, fontBody } = colors;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const UnitToggleStyled = styled.div``;

const highFontWeight = 600;
const lowFontWeight = 500;

export const UnitButton = styled.button<{ active: boolean }>`
  min-height: 24px;
  padding: 0px 10px;
  min-width: 50px;
  border: 0.5px solid ${darkInputBorder};
  color: ${props => (props.active ? primary : fontBody)};
  background-color: ${props => (props.active ? activeBackground : white)};
  font-weight: ${props => (props.active ? highFontWeight : lowFontWeight)};
  line-height: 1em;

  :active,
  :focus {
    outline: none;
  }

  :hover {
    cursor: pointer;
    background-color: ${globalInputSelectedBg} !important;
  }
`;

export const UnitButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${UnitButton}:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  ${UnitButton}:last-of-type {
    border-left: none;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

interface IUnitToggleProps {
  selectedUnitType: EEvaluationUnit;
  setCurrentUnitType: (unitType: string) => void;
  selectCurrentUnit: string;
}

const UnitToggles = ({ selectedUnitType, setCurrentUnitType, selectCurrentUnit }: IUnitToggleProps) => {
  const [isDollarSwitch, setIsDollarSwitch] = useState(false);
  const [isCentsSwitch, setIsCentsSwitch] = useState(false);

  useEffect(() => {
    if (selectedUnitType === EEvaluationUnit.TON) {
      setCurrentUnitType('dollarsPerTon');
      setIsDollarSwitch(true);
      setIsCentsSwitch(false);
    }
    if (selectedUnitType === EEvaluationUnit.LBS) {
      setCurrentUnitType('centsPerPound');
      setIsCentsSwitch(true);
      setIsDollarSwitch(false);
    }
  }, [selectedUnitType, setIsDollarSwitch, setCurrentUnitType]);

  return (
    <UnitToggleStyled>
      <UnitButtonContainer>
        {isDollarSwitch && (
          <>
            <UnitButton
              data-testid={testIdUnitToggleDollarPerTon}
              onClick={() => setCurrentUnitType('dollarsPerTon')}
              active={selectCurrentUnit === 'dollarsPerTon'}
            >
              {labels.currency.dollarsPerTon}
            </UnitButton>
            <UnitButton
              data-testid={testIdUnitToggleDollarPerTon}
              onClick={() => setCurrentUnitType('dollar')}
              active={selectCurrentUnit === 'dollar'}
            >
              {labels.currency.dollar}
            </UnitButton>
          </>
        )}
        {isCentsSwitch && (
          <>
            <UnitButton
              data-testid={testIdUnitToggleCentPerPound}
              onClick={() => setCurrentUnitType('centsPerPound')}
              active={selectCurrentUnit === 'centsPerPound'}
            >
              {labels.currency.centsPerPound}
            </UnitButton>
            <UnitButton
              data-testid={testIdUnitToggleCentPerPound}
              onClick={() => setCurrentUnitType('cents')}
              active={selectCurrentUnit === 'cents'}
            >
              {labels.currency.cents}
            </UnitButton>
          </>
        )}
      </UnitButtonContainer>
    </UnitToggleStyled>
  );
};

export default UnitToggles;
